import React from 'react';
import { BrowserRouter as Router, Redirect, Route, Switch } from 'react-router-dom';
import { LoginRoute, LogoutRoute, SignInCallbackRoute, SilentRefreshRoute, CaseStatusRoute } from './routes';
import CaseStatusVerification from './routes/CaseStatus/CaseStatusVerification';
import CasePaymentResultRoute from './routes/CaseStatus/CasePaymentResultRoute';
import { AppRoute } from './AppRoute';

function App() {

  return (
    <Router>
      <Switch>
        <Route path="/signin" exact={true} component={LoginRoute} />
        <Route exact path="/callback" component={SignInCallbackRoute} />
        <Route exact path="/silent-renew" component={SilentRefreshRoute} />
        <Route exact path="/logout" component={LogoutRoute} />
        <Route exact path="/case-status" component={CaseStatusRoute} />
        <Route exact path="/case-verify" component={CaseStatusVerification} />
        <Route exact path="/case-payment-result" component={CasePaymentResultRoute} />
        <AppRoute />
        <Route render={() => <Redirect to="/logout" />} />
      </Switch>
    </Router>
  );
}

export default App;
 